import React from 'react';
import { Form } from 'semantic-ui-react';

import FilterCardBoolean from '../FilterComponents/FilterCardBoolean';
import FilterCardKeyArray from '../FilterComponents/FilterCardKeyArray';
import FilterCardKeyValueArray from '../FilterComponents/FilterCardKeyValueArray';
import FilterCardNullableBoolean from '../FilterComponents/FilterCardNullableBoolean';
import FilterCardSelect from '../FilterComponents/FilterCardSelect';
import FilterCardSelectArray from '../FilterComponents/FilterCardSelectArray';
import FilterCardSelectRef from '../FilterComponents/FilterCardSelectRef';

import FilterIasBrandSafeties from '../../StaticData/FilterIasBrandSafeties';
import FilterIasViewabilities from '../../StaticData/FilterIasViewabilities';

type Props = {
  record: any,
  resource: string
};

const CommonFiltersColumn1 = (props: Props) => (
  <div >
    <Form.Field>
      <FilterCardSelectRef
        reference="helpers/publisher_codes"
        resource={props.resource}
        rootName="segment_attributes.filter_publisher_attributes"
        sort={{ field: 'name', order: 'ASC' }}
        title="Publishers"
        values={props.record.segment_attributes && props.record.segment_attributes.filter_publisher_attributes && props.record.segment_attributes.filter_publisher_attributes.values}
      /><br />
    </Form.Field>
    <Form.Field>
      <FilterCardKeyArray
        record={props.record}
        rootName="segment_attributes.filter_account_attributes"
        values={props.record.segment_attributes && props.record.segment_attributes.filter_account_attributes && props.record.segment_attributes.filter_account_attributes.values}
        title="Accounts" /><br />
    </Form.Field>
    <Form.Field>
      <FilterCardSelectRef
        reference="helpers/operating_systems"
        resource={props.resource}
        rootName="segment_attributes.filter_operating_system_attributes"
        sort={{ field: 'name', order: 'ASC' }}
        title="Operating Systems"
        values={props.record.segment_attributes && props.record.segment_attributes.filter_operating_system_attributes && props.record.segment_attributes.filter_operating_system_attributes.values} /><br />
    </Form.Field>
    <Form.Field>
      <FilterCardSelect
        choices={FilterIasViewabilities}
        record={props.record}
        rootName="segment_attributes.filter_ias_viewability_attributes"
        title="IAS Viewability Score"
        values={props.record.segment_attributes && props.record.segment_attributes.filter_ias_viewability_attributes && props.record.segment_attributes.filter_ias_viewability_attributes.values} /><br />
    </Form.Field>
    <Form.Field>
      <FilterCardSelectArray
        choices={FilterIasBrandSafeties}
        rootName="segment_attributes.filter_ias_brand_safety_attributes"
        title="IAS Brand Safety"
        values={props.record.segment_attributes && props.record.segment_attributes.filter_ias_brand_safety_attributes && props.record.segment_attributes.filter_ias_brand_safety_attributes.values} /><br />
    </Form.Field>
    <Form.Field>
      <FilterCardKeyValueArray
        record={props.record}
        rootName="segment_attributes.filter_header_attributes"
        title="HTTP Header"
        values={props.record.segment_attributes && props.record.segment_attributes.filter_header_attributes && props.record.segment_attributes.filter_header_attributes.values} /><br />
    </Form.Field>
    <Form.Field>
      <FilterCardNullableBoolean
        record={props.record}
        rootName="segment_attributes.filter_ias_fraud_attributes"
        title="Target IAS Fraud"
        values={props.record.segment_attributes && props.record.segment_attributes.filter_ias_fraud_attributes && props.record.segment_attributes.filter_ias_fraud_attributes.values} /><br />
    </Form.Field>
    <Form.Field>
      <FilterCardBoolean
        rootName="segment_attributes.filter_is_bot_attributes"
        title="Exclude NHT"
        values={props.record.segment_attributes && props.record.segment_attributes.filter_is_bot_attributes && props.record.segment_attributes.filter_is_bot_attributes.values} /><br />
    </Form.Field>
  </div>
);

export default CommonFiltersColumn1;



// WEBPACK FOOTER //
// ./src/views/Common/Filters/Column1.tsx